<template>
  <div>
    <div class="crumbs">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>
          <i class="el-icon-lx-cascades"></i> 采购审批流程
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="container">
      <el-form
        ref="workflowCompany"
        :rules="rules"
        :inline="true"
        :model="workflowCompany"
      >
        <el-form-item label="审批流程名称：" prop="workflowDefinitionName">
          <el-input
            v-model.trim="workflowCompany.workflowDefinitionName"
            maxlength="20"
            placeholder="请输入内容"
          ></el-input>
        </el-form-item>
      </el-form>
      <div class="tips">
        <span
          style="
            font-size: 12px;
            float: 20px;
            margin: 0 0 20px 5px;
            display: inline-block;
          "
        >
          说明：审批流程设置支持自定义审批层级节点，在每个节点中，可以设置多个审批人，其中的任何一人审批通过后即可进入下一层级审批节点。
        </span>
      </div>
      <!--表单添加-->
      <el-button type="success" @click="AddListRow('workflowCompany')"
        >添加审批节点</el-button
      >
      <TableList
        style="margin-top: 15px"
        :loading="false"
        :table-data="tableData"
        :table-label="tableLabel"
      >
        <template #idx="idx"> 第{{ idx.scope.$index + 1 }}审批节点 </template>
        <template #approver="approver">
          <el-col :span="18">
            <el-tooltip
              class="item"
              effect="light"
              :disabled="disabledFlag(approver.scope.row.approverList)"
              :content="approver.scope.row.approverList"
              placement="top"
            >
              <el-input
                v-model="approver.scope.row.approverList"
                style="width: 84%; margin-right: 10px"
                :disabled="true"
              />
            </el-tooltip>
          </el-col>
          <el-col :span="5">
            <el-button
              size="mini"
              type="primary"
              plain
              icon="el-icon-search"
              :disabled="false"
              @click="
                editApprover(
                  workflowCompany.workflowDefinitionName,
                  approver.scope.$index
                )
              "
            />
          </el-col>
        </template>
        <!-- 操作 -->
        <template #operation="tData">
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(tData.scope.$index)"
            >删除审批节点</el-button
          >
        </template>
      </TableList>
      <div style="margin-top: 20px; text-align: center">
        <el-button type="primary" @click="handleAddPurchase('workflowCompany')"
          >确定添加</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import TableList from '@/modules/projectA/components/common/e-table-list';
import { isSpace } from '../../utils/validate';
import Api from '../../api/company/index';

export default {
  name: '',
  components: {
    TableList,
  },
  data() {
    const validateSpace = (rule, value, callback) => {
      if (isSpace(value)) {
        return callback(new Error('请输入非空格字符！'));
      }
      if (!value) {
        return callback(new Error('请输入必填项！'));
      }
      return callback();
    };
    return {
      input: '',
      workflowCompany: {
        workflowDefinitionName: '',
        companyName: '',
        WorkflowCompanySku: [],
      },
      repetitionFlag: false,
      rules: {
        workflowDefinitionName: [
          {
            pattern: /^[\w\u4e00-\u9fa5]+$/,
            message: '输入框类型：汉字，英文，数字，英文下划线。',
            trigger: 'blur',
          },
          { required: true, trigger: 'blur', validator: validateSpace },
        ],
      },
      tableData: [],
      tableLabel: [
        {
          label: '审批节点',
          param: 'orderNo',
          align: 'center',
          slot: 'idx',
        },
        {
          label: '审批人',
          param: 'aftersalesNo',
          align: 'center',
          slot: 'approver',
        },
        {
          label: '操作',
          fixed: 'right',
          align: 'center',
          slot: 'operation',
        },
      ],
      approverEdit_flag: false,
    };
  },
  created() {
    if (
      JSON.parse(this.$getStore('createPurchaseAuditPath')).path ==
      'purchaseAudit'
    ) {
      this.$setStore('tableData', []);
      this.$setStore('confirmWorkFlowSkusList', null);
    } else {
      this.workflowCompany.workflowDefinitionName =
        this.$getStore('createName');
    }
    this.getApproverList();
  },
  methods: {
    // 点击加号添加一行数据
    AddListRow(workflowCompany) {
      this.$refs[workflowCompany].validate((valid) => {
        if (valid) {
          this.tableData.push({});
          this.$setStore(
            'workflowDefinitionName',
            this.workflowCompany.workflowDefinitionName
          );
          this.$setStore('tableData', this.tableData);
        } else {
          console.log('请输入审批流程名称');
          return false;
        }
      });
    },

    disabledFlag(val) {
      if (val) {
        return false;
      }
      return true;
    },

    handleDelete(index) {
      this.$confirm('该审批流程将被删除，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          try {
            // 弄明白 confirmWorkFlowSkusList 这是数组是干啥的
            this.tableData.splice(index, 1);
            const confirmWorkFlowSkusList = JSON.parse(
              this.$getStore('confirmWorkFlowSkusList')
            );
            const confirmWorkFlowSkusListAfter = [];
            if (
              confirmWorkFlowSkusList &&
              confirmWorkFlowSkusList.length >= 1
            ) {
              confirmWorkFlowSkusList.forEach((each) => {
                const level = parseInt(each.level);
                if (level < index + 1) {
                  confirmWorkFlowSkusListAfter.push(each);
                } else if (level > index + 1) {
                  const eachAfter = each;
                  const t = level + 1;
                  eachAfter.level = t;
                  confirmWorkFlowSkusListAfter.push(eachAfter);
                }
              });
            }

            this.$setStore(
              'confirmWorkFlowSkusList',
              confirmWorkFlowSkusListAfter
            );
            this.$setStore('tableData', this.tableData);
            this.$message({
              type: 'success',
              message: '删除成功!',
            });
            return;
          } catch (error) {
            console.log(error);
          }
        })
        .catch(() => {});
    },
    editApprover(workflowDefinitionName, index) {
      this.setApproverStore(workflowDefinitionName, index);
      this.$router.push({
        name: 'approverEdit',
        params: {
          workflowDefinitionName,
          index,
        },
      });
    },

    setApproverStore(workflowDefinitionName, index) {
      this.$setStore('workflowDefinitionName', workflowDefinitionName);
      this.$setStore('index', parseInt(index) + 1);
    },
    getApproverList() {
      this.$getStore('workflowDefinitionName') == ''
        ? ''
        : this.$getStore('workflowDefinitionName');
      const confirmWorkFlowSkusList = JSON.parse(
        this.$getStore('confirmWorkFlowSkusList')
      );

      const tableData = JSON.parse(this.$getStore('tableData'));
      if (tableData != null) {
        this.tableData = JSON.parse(this.$getStore('tableData'));
      }
      if (confirmWorkFlowSkusList == null) {
        return;
      }
      const testArr = [];
      for (let i = 0; i < confirmWorkFlowSkusList.length; i++) {
        this.tableData[i] = {
          levelName: '',
          approverList: '',
        };
        this.tableData[
          i
        ].levelName = `第${confirmWorkFlowSkusList[i].level}审批节点`;
        let t = '';
        for (
          let j = 0;
          j < confirmWorkFlowSkusList[i].approverList.length;
          j++
        ) {
          t += `${confirmWorkFlowSkusList[i].approverList[j].realName};`;
        }

        testArr.push(t);
        this.tableData[i].approverList = t;
      }
    },
    handleAddPurchase(workflowCompany) {
      if (this.workflowCompany.workflowDefinitionName == '') {
        this.$refs[workflowCompany].validate((valid) => {
          if (!valid) {
            return false;
          }
        });
        return;
      }
      const dataArr = JSON.parse(this.$getStore('getWorkflowListTableData'));
      dataArr.map((item) => {
        if (
          item.workflowDefinitionName ==
          this.workflowCompany.workflowDefinitionName
        ) {
          this.repetitionFlag = true;
        }
      });
      if (this.repetitionFlag) {
        this.repetitionFlag = false;
        return this.$message.error('已存在同名称审批流程，请重新命名!');
      }
      if (this.tableData.length < 1) {
        this.$message({
          type: 'error',
          message: '请先添加审批节点！',
        });
        return;
      }
      const confirmWorkFlowSkusList = JSON.parse(
        this.$getStore('confirmWorkFlowSkusList')
      );
      this.tableData.map((item) => {
        if (item.approverList == '') {
          this.$message({
            type: 'info',
            message: '某审批节点为空，请查看！',
          });
        }
      });
      if (
        confirmWorkFlowSkusList == null ||
        confirmWorkFlowSkusList.length != this.tableData.length
      ) {
        this.$message({
          type: 'info',
          message: '某审批节点为空，请查看！',
        });
        return;
      }
      const params = {
        workflowDefinitionName: '',
        workflowSkus: [],
      };
      params.workflowDefinitionName =
        this.workflowCompany.workflowDefinitionName;

      confirmWorkFlowSkusList.forEach((param) => {
        param.approverList.forEach((skuParam) => {
          const each = {
            approverContact: skuParam.mobile,
            approverId: skuParam.memberId,
            approverName: skuParam.memberName,
            approverRealName: skuParam.realName,
            levelName: `第${param.level}审批节点`,
            level: param.level,
            companyName: '',
          };
          params.workflowSkus.push(each);
        });
      });
      Api.addWorkflow(params).then((res) => {
        if (res.code == '200') {
          this.$message({
            type: 'success',
            message: '添加成功!',
          });
          this.removeStore();
          this.goToUrl('/purchaseAudit');
        } else {
          // this.$message({
          //   type: "info",
          //   message: res.message,
          // });
        }
      });
    },
    goToUrl(url) {
      this.$store.state.tagsList.map((item, index) => {
        if (item.fullPath == this.$route.path) {
          this.$store.state.tagsList.splice(index, 1);
        }
      });
      this.$router.push({ path: url });
    },
    removeStore() {
      this.$setStore('workflowDefinitionName', '');
      this.$setStore('index', null);
      this.$setStore('tableData', null);
      this.$setStore('workFlowSkusList', null);
      this.$setStore('confirmWorkFlowSkusList', null);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep.el-form-item--small .el-form-item__error {
  width: 270px;
}
</style>
